module.exports = __webpack_public_path__ + "static/media/due-port02.4ae9b803.jpg";